import { render, staticRenderFns } from "./ReceivableDetail.vue?vue&type=template&id=66dd3ef7&scoped=true"
import script from "./ReceivableDetail.vue?vue&type=script&lang=js"
export * from "./ReceivableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd3ef7",
  null
  
)

export default component.exports